import { WetookMark } from '../components/WetookMark'

export default function AccessDeniedPage() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-background gap-6 text-center px-6">
      <WetookMark className="w-20 h-20 text-foreground opacity-80" />
      <div className="space-y-2">
        <p className="text-[11px] font-bold uppercase tracking-widest text-muted-foreground/60">
          403 — Access Restricted
        </p>
        <h1 className="text-2xl font-bold text-foreground">Your account has been suspended</h1>
        <p className="text-[14px] text-muted-foreground max-w-xs mx-auto leading-relaxed">
          Access to this app has been restricted by your administrator.
          Please reach out to them to restore access.
        </p>
      </div>
    </div>
  )
}
